/**
 * "Recent files" — one entry per document uuid, holding its last-known content
 * so the user can reopen a recently edited script without re-importing the file.
 */
import { getDB, type RecentEntry } from "./db";

/** Insert or update the recent entry for a document. */
export async function putRecent(entry: RecentEntry): Promise<void> {
  const db = await getDB();
  await db.put("recent", entry);
}

/** All recent documents, newest first. */
export async function listRecent(): Promise<RecentEntry[]> {
  const db = await getDB();
  const all = await db.getAll("recent");
  return all.sort((a, b) => b.ts - a.ts);
}

export async function getRecent(uuid: string): Promise<RecentEntry | undefined> {
  const db = await getDB();
  return db.get("recent", uuid);
}

export async function deleteRecent(uuid: string): Promise<void> {
  const db = await getDB();
  await db.delete("recent", uuid);
}
